import React, { useRef } from 'react';
import Slider from 'react-slick';
import { Icon } from '@iconify/react';

export default function BrandsCarousel({ data }) {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    cssEase: 'ease-in-out',
    slidesToShow: 4,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="cs_partners_slider_wrap">
      <button
        className="cs_partners_arrow cs_partners_arrow_left"
        onClick={() => sliderRef.current?.slickPrev()}
        aria-label="Previous"
      >
        <Icon icon="fa6-solid:chevron-left" />
      </button>
      <Slider ref={sliderRef} {...settings} className="cs_gap_20 cs_partners_carousel">
        {data?.map((item, index) => (
          <div key={index}>
            <div className="cs_partner_card">
              <img src={item.imgUrl} alt={item.imgAlt} />
            </div>
          </div>
        ))}
      </Slider>
      <button
        className="cs_partners_arrow cs_partners_arrow_right"
        onClick={() => sliderRef.current?.slickNext()}
        aria-label="Next"
      >
        <Icon icon="fa6-solid:chevron-right" />
      </button>
    </div>
  );
}